<template>
  <div class="content_container">
    <p class="title_box">招商代理</p>
    <div class="response_container">
      <div class="left_wrap">
        <div class="img_box">
          <img :src="require('@/assets/img/join/agent_1.jpg')" alt="">
        </div>
      </div>
      <div class="right_wrap">
        <div class="articleText">
          <div class="article_wrap" v-for="( item, index ) in articleText " :key="index">
            <div class="subTitle_box">{{item.subTitle}}</div>
            <div class="text_box" v-for="( textItem, textIndex ) in item.article  " :key="`${index}-${textIndex}`">{{textItem}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        articleText: [
          {
            subTitle: '招商要求',
            article: [
              '1、认同瑞谦智能企业发展理念',
              '2、有一定的资金基础，能够启动市场运作',
              '3、具备3人以上的市场营销和售后服务团队',
              '4、有良好的社会关系和背景，确保市场顺畅运转',
              '5、拥有成熟渠道和行业运作经验',
              '\u00A0'
            ]
          },
          {
            subTitle: '申请流程',
            article: [
              '在线申请、商户洽谈、资质审核、签订协议',
              '合作热线：400-8775178（周一至周五8:30-17:30）'
            ]
          }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
.content_container {
  min-height: 300px;
  margin: 0;
  padding: 4% 0 8% 0;
}
.title_box {
  margin-bottom: 40px;
  text-align: center;
  font-size: 24px;
  color: rgba(38, 38, 38, 1);
}
.response_container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 94%;
  max-width: 1280px;
  margin: 0 auto 24px auto;
  .left_wrap {
    align-self: center;
    flex: 1;
    max-width: 100%;
    max-height: 100%;
    .img_box {
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .right_wrap {
    align-self: center;
    flex: 1;
    max-width: 100%;
    max-height: 100%;
    .articleText {
      padding-left: 50px;
      .subTitle_box {
        line-height: 34px;
        font-size: 20px;
        font-weight: 700;
        color:#333333;
      }
      .text_box {
        line-height: 34px;
        font-size: 16px;
        color: rgb(85, 85, 85);
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .response_container {
    flex-direction: column;
  }
}
</style>
